import { COLLECTION_LAYOUT_LIST } from '../../utils/constans/collectionLayoutSelectorList';
import { CollectionListWrapper } from './CollectionListView/CollectionListWrapper';
import React, { useEffect, useRef, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CollectionLoadingLayout } from '../layouts/LoadingLayouts/CollectionLoadingLayout';
import { CollectionActionWrapper } from './CollectionActions/CollectionActionsWrapper';
import { CollectionGridWrapper } from './CollectionGridView/CollectionGridWrapper';
import useProductFilterSWR from '../../hooks/products/useProductFilterSWR';
import { CollectionPagination } from './CollectionPagination';
import { CollectionWrapperProps } from '../../models/CollectionFilter';
import { useAppSelector } from 'redux/hooks';

export const CollectionWrapper: React.FC<CollectionWrapperProps> = (props) => {
    const [selectedLayout, setSelectedLayout] = useState(
        COLLECTION_LAYOUT_LIST[0]
    );
    const { collectionIds, search, handle } = props;
    const { t } = useTranslation('collection');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const myRef = useRef(null);
    const productPerPage = 50;
    const [pagination, setPagination] = useState<number>(1);
    const [sort, setSort] = useState<string>('ALPHABETICAL_ASC');
    const [reset, setReset] = useState<boolean>(false);
    const { filter } = useAppSelector((state) => state.filter);
    const { products, count, isLoading, isError } = useProductFilterSWR({
        collectionIds: collectionIds,
        search: search,
        perPage: productPerPage,
        page: pagination,
        sortKey: sort,
        tags: [...filter.filteredItems],
        priceRange: {
            min: filter.priceRange[0],
            max: filter.priceRange[1],
        },
    });

    useEffect(() => {
        setPagination(1);
    }, [collectionIds]);

    const handleSelectLayout = (id) => {
        setSelectedLayout(COLLECTION_LAYOUT_LIST.find((elem) => elem.id == id));
    };

    const executeScroll = () => myRef.current.scrollIntoView();

    const handlePagination = (pageNumber) => {
        executeScroll();
        setPagination(pageNumber);
        setReset(!reset);
    };

    const handleSort = (elem) => {
        setPagination(1);
        setSort(elem);
    };

    return (
        <>
            <div ref={myRef}></div>
            <CollectionActionWrapper
                collectionIds={collectionIds}
                handleSelectLayout={handleSelectLayout}
                selectedLayout={selectedLayout.id}
                handleSortSelect={handleSort}
                sort={sort}
                search={''}
            />
            {isLoading && <CollectionLoadingLayout />}
            {isError && (
                <Box>{t('COLLECTIONS.REQUEST_ERROR').toUpperCase()}</Box>
            )}
            {products && products.length > 0 && (
                <Box>
                    {selectedLayout.type == 'list' && !isMobile && (
                        <CollectionListWrapper
                            products={products}
                            handle={handle}
                        />
                    )}
                    {(selectedLayout.type == 'grid' || isMobile) && (
                        <CollectionGridWrapper
                            gridSize={
                                isMobile
                                    ? 1
                                    : isSmallScreen
                                    ? 2
                                    : selectedLayout.gridSize
                            }
                            products={products}
                            handle={handle}
                        />
                    )}
                </Box>
            )}
            {products && products.length == 0 && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '10px 0',
                        fontSize: '16px',
                    }}
                >
                    {t('COLLECTIONS.NO_PRODUCTS').toUpperCase()}
                </Box>
            )}

            <CollectionPagination
                handlePagination={handlePagination}
                count={count}
                productsPerPage={productPerPage}
                pagination={pagination}
            />
        </>
    );
};
